function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.23659 4.9388H5.56576L7.64492 7.02214L7.02409 7.64297L4.94076 5.5638V5.23464L4.82826 5.11797C4.35326 5.5263 3.73659 5.77214 3.06576 5.77214C1.56992 5.77214 0.357422 4.55964 0.357422 3.0638C0.357422 1.56797 1.56992 0.355469 3.06576 0.355469C4.56159 0.355469 5.77409 1.56797 5.77409 3.0638C5.77409 3.73464 5.52826 4.3513 5.11992 4.8263L5.23659 4.9388ZM1.19121 3.06392C1.19121 4.10142 2.02871 4.93892 3.06621 4.93892C4.10371 4.93892 4.94121 4.10142 4.94121 3.06392C4.94121 2.02642 4.10371 1.18892 3.06621 1.18892C2.02871 1.18892 1.19121 2.02642 1.19121 3.06392Z"
});

var SvgSearchLoop = function SvgSearchLoop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_loop.bde45aac.svg";
export { ForwardRef as ReactComponent };